import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import qs from 'qs';

const queryFn = ({ projectId }: QueryParams) => {
    const querystring = qs.stringify({ projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/management/getContractTagsInit${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};

export const useQueryGetTagListInit = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getTagListInit'],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.projectId),
    });
};

interface QueryParams {
    projectId?: number;
}

interface QueryResponse {
    tags: { id: number; name: string }[];
}
